<div class="full-screen-loader">
  <mat-spinner color="primary" strokeWidth="10" diameter="120" />
</div>
